(function () {
  if (window.__mtComboFlowInitialized) return;
  window.__mtComboFlowInitialized = true;

  var stateKey = "mt_combo_flow_v1";
  var pendingKey = "mt_combo_flow_pending_v1";
  var maxAge = 30 * 60 * 1000;

  function readState() {
    try {
      var state = JSON.parse(sessionStorage.getItem(stateKey) || "null");
      if (!state || !state.startedAt || Date.now() - state.startedAt > maxAge) {
        sessionStorage.removeItem(stateKey);
        sessionStorage.removeItem(pendingKey);
        return null;
      }
      return state;
    } catch (error) {
      return null;
    }
  }

  function writeState(stage, params) {
    var state = { stage: stage, params: params || "", startedAt: Date.now() };
    sessionStorage.setItem(stateKey, JSON.stringify(state));
    return state;
  }

  function retainedParams() {
    var params = new URLSearchParams(window.location.search);
    params.delete("combo_flow");
    return params.toString();
  }

  function withParams(path, stage, savedParams) {
    var params = new URLSearchParams(savedParams || "");
    params.set("combo_flow", stage);
    return path + "?" + params.toString();
  }

  function shoesUrl(state) {
    return withParams("/collections/tenis", "shoe", state.params);
  }

  function discountedCartUrl(state) {
    var params = new URLSearchParams(state.params || "");
    params.set("combo", "combo-em-campo");
    params.set("combo_flow", "done");
    return (
      "/discount/COMBOEMCAMPO30?redirect=" +
      encodeURIComponent("/cart?" + params.toString())
    );
  }

  function finishRedirect(state) {
    sessionStorage.removeItem(pendingKey);
    sessionStorage.removeItem(stateKey);
    window.location.assign(discountedCartUrl(state));
  }

  var query = new URLSearchParams(window.location.search);
  var requestedStage = query.get("combo_flow");
  var state = readState();

  if (requestedStage === "shirt") {
    state = writeState("shirt", retainedParams());
  } else if (requestedStage === "shoe" && state) {
    state = writeState("shoe", state.params);
  } else if (requestedStage === "done") {
    sessionStorage.removeItem(stateKey);
    sessionStorage.removeItem(pendingKey);
    state = null;
  }

  var pending = sessionStorage.getItem(pendingKey);
  if (/\/cart\/?$/.test(window.location.pathname) && state && pending) {
    if (state.stage === "shirt") {
      sessionStorage.removeItem(pendingKey);
      state = writeState("shoe", state.params);
      window.location.replace(shoesUrl(state));
      return;
    }
    if (state.stage === "shoe") {
      finishRedirect(state);
      return;
    }
  }

  document.addEventListener(
    "click",
    function (event) {
      var trigger = event.target.closest("[data-combo-start]");
      if (!trigger) return;
      event.preventDefault();
      var nextState = writeState("shirt", retainedParams());
      window.location.assign(
        withParams(trigger.getAttribute("href"), "shirt", nextState.params),
      );
    },
    true,
  );

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || !form.action || form.action.indexOf("/cart/add") === -1)
        return;
      if (!readState()) return;
      sessionStorage.setItem(pendingKey, "1");
    },
    true,
  );

  var nativeFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var target = args[0];
    var url =
      typeof target === "string"
        ? target
        : target && target.url
          ? target.url
          : "";
    return nativeFetch.apply(window, args).then(function (response) {
      var currentState = readState();
      if (!currentState || !response.ok || url.indexOf("/cart/add") === -1)
        return response;

      sessionStorage.removeItem(pendingKey);
      if (currentState.stage === "shirt") {
        currentState = writeState("shoe", currentState.params);
        window.setTimeout(function () {
          window.location.assign(shoesUrl(currentState));
        }, 80);
      } else if (currentState.stage === "shoe") {
        window.setTimeout(function () {
          finishRedirect(currentState);
        }, 80);
      }
      return response;
    });
  };
})();
